<template>
  <div class="gpsr-eidt-view">
    <Spin v-if="pageLoading" fix></Spin>
    <!-- <div class="head-btn">
      <span class="text-underline" @click="openTemplateModal">GPSR填写模板管理</span>
      <span class="text-underline ml20" @click="openEditModal">编辑GPSR资料</span>
    </div> -->
    <div class="product-details mb15" v-if="!$common.isEmpty(productInfo)">
      <div class="product-item">
        <label class="product-item-label">SPU:</label>
        <div class="details-value">{{ productInfo.spu }}</div>
      </div>
      <div class="product-item">
        <label class="details-label">中文品名:</label>
        <div class="details-value">{{ productInfo.cnName }}</div>
      </div>
      <div class="product-item">
        <label class="details-label">英文品名:</label>
        <div class="details-value">{{ productInfo.enName }}</div>
      </div>
      <div class="product-item">
        <label class="details-label">分类:</label>
        <div class="details-value">{{ productCategory.productCategoryNavigation }}</div>
      </div>
    </div>
    <div class="product-details mb15" v-if="!$common.isEmpty(batchQueryParams)">
      <div class="item-warning">提示：批量修改GPSR标签资料功能，适用于相同GPSR标签的产品，批量修改资料后，将覆盖原来的资料，请谨慎使用！</div>
    </div>
    <Form
      ref="modalFormRef"
      :model="modalFormData"
      :rules="modalFormRules"
      :label-width="0"
      class="mt10 modal-form-edit"
    >
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">1、产品信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-half align-items-top not-bottom">
            <label class="details-label">Product name:</label>
            <div class="details-value">
              <FormItem label="" prop="productName">
                <dytInput v-model="modalFormData.productName" placeholder="请输入Product name" />
              </FormItem>
              <div class="txt-tips">如不填写，打印标签时，使用：SPU的英文品名</div>
            </div>
          </div>
          <div class="details-item container-half align-items-top not-bottom">
            <label class="details-label">Model:</label>
            <div class="details-value">
              <FormItem label="" prop="model">
                <dytInput v-model="modalFormData.model" placeholder="请输入Model" />
              </FormItem>
              <div class="txt-tips">如不填写，打印标签时，使用：SKU编码</div>
            </div>
          </div>
          <div class="details-item container-half align-items-top not-bottom">
            <label class="details-label">Batch number:</label>
            <div class="details-value">
              <FormItem label="" prop="batchNumber">
                <dytInput v-model="modalFormData.batchNumber" placeholder="请输入Batch number" />
              </FormItem>
              <div class="txt-tips">如不填写，打印标签时，使用：自动按规则生成批次号</div>
            </div>
          </div>
          <div class="details-item container-half align-items-top not-bottom">
            <label class="details-label">Made in:</label>
            <div class="details-value">
              <FormItem label="" prop="madeIn">
                <dytInput v-model="modalFormData.madeIn" placeholder="请输入place of origin" />
              </FormItem>
              <div class="txt-tips">如不填写，打印标签时，使用：CHINA</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">2、生产商信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-half align-items-top">
            <label class="details-label">生产商信息:</label>
            <div class="details-value">
              <FormItem label="" prop="manufacturerInfoId">
                <dyt-select v-model="modalFormData.manufacturerInfoId" placeholder="请选择生产商信息">
                  <Option
                    v-for="(item, oIndex) in manufacturerData"
                    :value="item.manufacturerInfoId"
                    :key="`${item.manufacturerInfoId}-${oIndex}`"
                    :label="item.name"
                    @click.native="manufacturerIdChange(item.manufacturerInfoId)"
                  />
                </dyt-select>
              </FormItem>
            </div>
          </div>
          <div class="details-item container-half">
            <label class="details-label"></label>
            <div class="details-value"></div>
          </div>
          <div class="details-item container-half align-items-top">
            <label class="details-label label-required">Manufacturer:</label>
            <div class="details-value">
              <FormItem label="" prop="manufacturer">
                <dytInput v-model="modalFormData.manufacturer" placeholder="请输入Manufacturer" />
              </FormItem>
            </div>
          </div>
          <div class="details-item container-half align-items-top">
            <label class="details-label label-required">Address:</label>
            <div class="details-value">
              <FormItem label="" prop="address">
                <dytInput v-model="modalFormData.address" placeholder="请输入Address" />
              </FormItem>
            </div>
          </div>
          <div class="details-item container-half align-items-top">
            <label class="details-label label-required">e-mail:</label>
            <div class="details-value">
              <FormItem label="" prop="eMail">
                <dytInput v-model="modalFormData.eMail" placeholder="请输入e-mail" />
              </FormItem>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding container-half content-inline">
        <div class="item-title">
          <div class="title-text">3、欧代信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-full align-items-top">
            <label class="details-label label-required">欧代信息:</label>
            <div class="details-value">
              <FormItem label="" prop="europeAgentInfoId">
                <dyt-select v-model="modalFormData.europeAgentInfoId" placeholder="请选择欧代信息">
                  <Option
                    v-for="(item, oIndex) in europeData"
                    :value="item.europeAgentInfoId"
                    :key="`${item.europeAgentInfoId}-${oIndex}`"
                    :label="item.europeAgentName"
                  />
                </dyt-select>
              </FormItem>
            </div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Name:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.name }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Address:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.address }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">e-mail:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.eMail }}</div>
          </div>
        </div>
        <div class="item-label-tip">
          <div class="label-tip-item">EU</div>
          <div class="label-tip-item">REP</div>
        </div>
      </div>
      <div class="content-item content-padding container-half content-inline">
        <div class="item-title">
          <div class="title-text">4、英代信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-full align-items-top">
            <label class="details-label">英代信息:</label>
            <div class="details-value">
              <FormItem label="" prop="britainAgentInfoId">
                <dyt-select v-model="modalFormData.britainAgentInfoId" placeholder="请选择英代信息">
                  <Option
                    v-for="(item, oIndex) in britainData"
                    :value="item.britainAgentInfoId"
                    :key="`${item.britainAgentInfoId}-${oIndex}`"
                    :label="item.britainAgentName"
                  />
                </dyt-select>
              </FormItem>
            </div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Name:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.name }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Address:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.address }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">e-mail:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.eMail }}</div>
          </div>
        </div>
        <div class="item-label-tip">
          <div class="label-tip-item">UK</div>
          <div class="label-tip-item">REP</div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">5、安全警告信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-half align-items-top">
            <label class="details-label label-required">安全警告信息：</label>
            <div class="details-value">
              <FormItem label="" prop="securityWarningInfoId">
                <dyt-select v-model="modalFormData.securityWarningInfoId" placeholder="请选择安全警告信息">
                  <Option
                    v-for="(item, oIndex) in warningData"
                    :value="item.securityWarningInfoId"
                    :key="`${item.securityWarningInfoId}-${oIndex}`"
                    :label="item.name"
                  />
                </dyt-select>
              </FormItem>
            </div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">WARNING：</label>
            <div class="details-value style-pre-wrap">{{ gpsrSecurityWarningInfoVO.warning }}</div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">6、安全/环保/认证标识</div>
        </div>
        <div class="item-details">
          <div class="details-item container-half align-items-top not-vertical-center">
            <label class="details-label label-required">安全/环保/认证标识：</label>
            <div class="details-value">
              <FormItem label="" prop="identificationInfoId">
                <dyt-select v-model="modalFormData.identificationInfoId" placeholder="请选择安全/环保/认证标识">
                  <Option
                    v-for="(item, oIndex) in identificationListData"
                    :value="item.identificationInfoId"
                    :key="`${item.identificationInfoId}-${oIndex}`"
                    :label="item.name"
                  />
                </dyt-select>
              </FormItem>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-details" style="margin-top: 0;">
          <div class="details-item container-full align-items-top not-vertical-center">
            <label class="details-label"></label>
            <div class="details-value">
              <div class="details-img-list">
                <img
                  v-for="(item, index) in (gpsrIdentificationInfoVO.identificationData || [])"
                  :src="item.path"
                  :alt="item.name"
                  :title="item.name"
                  :key="`${item.path}-${index}`"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>

  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: "gpsrEditView",
  components: {},
  props: {
    moduleData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      pageLoading: true,
      modalFormData: {
        productName: '',
        model: '',
        batchNumber: '',
        madeIn: '',
        manufacturer: '',
        address: '',
        eMail: '',
        britainAgentInfoId: null,
        europeAgentInfoId: null,
        identificationInfoId: null,
        manufacturerInfoId: null,
        securityWarningInfoId: null
      },
      modalFormRules: {
        // britainAgentInfoId: [
        //   { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请选择英代信息' }
        // ],
        europeAgentInfoId: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请选择欧代信息' }
        ],
        identificationInfoId: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请选择安全/环保/认证标识' }
        ],
        manufacturer: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'blur', msg: '请输入Manufacturer' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'change', msg: '请输入Manufacturer' }
        ],
        address: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'blur', msg: '请输入Address' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'change', msg: '请输入Address' }
        ],
        eMail: [
          { required: true, validator: this.$common.verifyEmail, trigger: 'blur', msg: '请输入e-mail' },
          { required: true, validator: this.$common.verifyEmail, trigger: 'change', msg: '请输入e-mail' }
        ],
        securityWarningInfoId: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请选择安全警告信息' }
        ]
      },
      manufacturerData: [],
      warningData: [],
      identificationListData: [],
      europeData: [],
      britainData: []
    };
  },
  watch: {},
  computed: {
    // 获取所有事业部
    allBusinessDept() {
      return this.$store.getters.getBusinessDeptList || [];
    },
    // 可查看(有权限)的事业部ID
    businessDeptIdList () {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return [];
      if (this.$common.isEmpty(this.$store.getters['authUserInfo'].securityUser.businessDeptIds)) return [];
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds.split(',');
    },
    // 可查看(有权限)的事业部信息
    businessDeptInfo () {
      if (this.$common.isEmpty(this.allBusinessDept) || this.$common.isEmpty(this.businessDeptIdList)) return [];
      const filterList = this.allBusinessDept.filter(item => this.businessDeptIdList.includes((item.id).toString()));
      return filterList;
    },
    // 列表查询到的分类对象
    productGoodsListDictionary () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.productGoodsListDictionary)) return {};
      return this.moduleData.productGoodsListDictionary;
    },
    // 分类信息
    productCategory () {
      if (this.$common.isEmpty(this.productInfo)) return {};
      if (this.$common.isEmpty(this.productInfo.productCategoryId)) return {};
      if (this.$common.isEmpty(this.productGoodsListDictionary)) {
        return {
          productCategoryNavigation: this.productInfo.productCategoryId
        };
      }
      const info = this.productGoodsListDictionary[this.productInfo.productCategoryId];
      if (this.$common.isEmpty(info)) return {};
      return info;
    },
    // 批量查询时候的条件
    batchQueryParams () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.batchQueryParams)) return {};
      return this.moduleData.batchQueryParams;
    },
    // 标识图片
    iconDataList () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.iconDataList)) return [];
      return this.moduleData.iconDataList;
    },
    productInfo () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.productInfo)) return {};
      return this.moduleData.productInfo;
    },
    pageDetails () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.data)) return {};
      return this.moduleData.data;
    },
    // 欧代信息
    gpsrEuropeAgentInfoVO () {
      const info = this.europeData.find(item => item.europeAgentInfoId == this.modalFormData.europeAgentInfoId);
      return info || {};
    },
    // 英代信息
    gpsrBritainAgentInfoVO () {
      const info = this.britainData.find(item => item.britainAgentInfoId == this.modalFormData.britainAgentInfoId);
      return info || {};
    },
    // 安全警告信息
    gpsrSecurityWarningInfoVO () {
      const info = this.warningData.find(item => item.securityWarningInfoId == this.modalFormData.securityWarningInfoId);
      return info || {};
    },
    // 标识信息
    gpsrIdentificationInfoVO () {
      let info = this.identificationListData.find(item => item.identificationInfoId == this.modalFormData.identificationInfoId);
      if (!this.$common.isEmpty(info) && !this.$common.isEmpty(info.identificationType)) {
        const typeList = info.identificationType.split(',');
        let newTypeInfo = [];
        this.iconDataList.forEach(item => {
          if (typeList.includes(item.identificationType)) {
            newTypeInfo.push(item);
          }
        });
        info.identificationData = newTypeInfo;
      }
      return info || {};
    },
  },
  created() {
    this.pageLoading = true;
  },
  mounted () {
    this.$nextTick(() => {
      this.initPage().finally(() => {
        this.pageLoading = false;
      });
    })
  },
  methods: {
    // 初始化数据
    initPage () {
      return new Promise((resolve) => {
        let awaitRes = [
          this.getBritainList, this.getEuropeList, this.getManufacturerList, this.getIdentificationList, this.getWarningList,
          this.getDetails
        ];
        this.$common.promiseAll(awaitRes).finally(() => {
          this.oldManufacturerDataInfo = this.manufacturerData.find(item => item.manufacturerInfoId == this.modalFormData.manufacturerInfoId) || {};
          if (this.$common.isEmpty(this.gpsrBritainAgentInfoVO)) {
            this.modalFormData.britainAgentInfoId = null;
          }
          if (this.$common.isEmpty(this.gpsrEuropeAgentInfoVO)) {
            this.modalFormData.europeAgentInfoId = null;
          }
          if (this.$common.isEmpty(this.gpsrIdentificationInfoVO)) {
            this.modalFormData.identificationInfoId = null;
          }
          if (this.$common.isEmpty(this.oldManufacturerDataInfo)) {
            this.modalFormData.manufacturerInfoId = null;
          }
          if (this.$common.isEmpty(this.gpsrSecurityWarningInfoVO)) {
            this.modalFormData.securityWarningInfoId = null;
          }
          resolve({ state: 'end' });
        });
      })
    },
    // 详情
    getDetails () {
      return new Promise((resolve) => {
        if (!this.$common.isEmpty(this.pageDetails)) {
          Object.keys(this.modalFormData).forEach(key => {
            if (!this.$common.isUndefined(this.pageDetails[key])) {
              this.modalFormData[key] = this.pageDetails[key];
            }
          });
        }
        this.$set(this.modalFormData, 'productId', this.productInfo.productId || '');
        resolve({ state: 'finally' });
      })
    },
    // 重新选择生产商信息
    manufacturerIdChange () {
      const info = this.manufacturerData.find(item => item.manufacturerInfoId == this.modalFormData.manufacturerInfoId);
      if (this.$common.isEmpty(info)) return;
      Object.keys(this.modalFormData).forEach(key => {
        if (key != 'manufacturerInfoId' && !this.$common.isUndefined(info[key])) {
          this.modalFormData[key] = info[key];
        }
      });
    },
    // 获取英代列表
    getBritainList () {
      return new Promise((resolve) => {
        this.britainData = [];
        this.axios.get(api.britainDropdownList, {
          params: {
            businessDeptIds: this.businessDeptIdList.join(',')
          }
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            this.britainData = res.data.datas || [];
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取欧代列表
    getEuropeList () {
      return new Promise((resolve) => {
        this.europeData = [];
        this.axios.get(api.europeDropdownList, {
          params: {
            businessDeptIds: this.businessDeptIdList.join(',')
          }
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            this.europeData = res.data.datas || [];
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取生产商列表
    getManufacturerList () {
      return new Promise((resolve) => {
        this.manufacturerData = [];
        this.axios.get(api.manufacturerDropdown, {
          params: {
            businessDeptIds: this.businessDeptIdList.join(',')
          }
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            this.manufacturerData = res.data.datas || [];
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取标识列表
    getIdentificationList () {
      return new Promise((resolve) => {
        this.identificationListData = [];
        this.axios.get(api.identificationDropdown, {
          params: {
            businessDeptIds: this.businessDeptIdList.join(',')
          }
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            this.identificationListData = res.data.datas || [];
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取警告列表
    getWarningList () {
      return new Promise((resolve) => {
        this.warningData = [];
        this.axios.get(api.warningDropdown, {
          params: {
            businessDeptIds: this.businessDeptIdList.join(',')
          }
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            this.warningData = res.data.datas || [];
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 保存表单数据
    saveFormData (obj) {
      return new Promise((resolve) => {
        this.$refs.modalFormRef.validate((valid) => {
          if (!valid) {
            this.$common.inputFocus('modal-form-edit');
            return resolve({ valid: false, state: 'fail' })
          };
          this.pageLoading = true;
          let newRes = this.$common.copy(this.modalFormData);
          if (!this.$common.isEmpty(this.batchQueryParams)) {
            delete newRes.productId;
            let searchParams = this.$common.copy(this.batchQueryParams);
            delete searchParams.productIdList;
            delete searchParams.selectAll;
            newRes.selectAll = this.batchQueryParams.selectAll;
            newRes.queryProductGoodsBo = searchParams;
            if (!this.$common.isEmpty(this.batchQueryParams.productIdList)) {
              newRes.productIdList = this.batchQueryParams.productIdList;
            }
          }
          this.axios[obj.method](obj.saveApi, newRes).then(res => {
            this.pageLoading = false;
            if (res && res.data && res.data.code == 0) {
              resolve({ valid: true, state: 'success' });
            } else {
              resolve({ valid: true, state: 'fail' });
            }
          }).catch(() => {
            this.pageLoading = false;
            resolve({ valid: true, state: 'fail' });
          })
        })
      })
    }
  }
};
</script>
<style lang="less" scoped>
.gpsr-eidt-view {
  position: relative;
  margin: 15px 10px 10px 10px;
  max-height: calc(100% - 25px);
  font-size: 14px;
  overflow: auto;
  .item-warning {
    display: inline-block;
    margin-left: 50px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #fff;
    background: #ff9b00;
  }
  .head-btn{
    padding: 0 100px 0 30px;
    text-align: right;
  }
  .text-underline{
    cursor: pointer;
    text-decoration: underline;
    text-underline-position: under;
    color: #0000ff;
  }
  .content-padding {
    padding: 0 10px;
  }
  .content-item{
    .item-title{
      position: relative;
      &:before {
        position: absolute;
        content: '';
        height: 100%;
        width: 4px;
        background: #2d8cf0;
      }
      .title-text{
        padding-left: 10px;
      }
    }
    .item-details{
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
    }
  }
  .details-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    &.align-items-top{
      align-items: flex-start;
      margin-bottom: 0;
      .details-label {
        line-height: 32px;
      }
    }
    &.not-bottom{
      :deep(.ivu-form-item){
        margin-bottom: 0;
      }
    }
    &.container-full{
      &:nth-of-type(2n-1) {
        padding-right: 0;
      }
      &:nth-of-type(2n) {
        padding-left: 0;
      }
    }
    .txt-tips{
      margin-top: 2px;
      margin-bottom: 5px;
      font-size: 12px;
      color: #7d7d7d;
    }
    .details-label{
      position: relative;
      width: 220px;
      line-height: 1.2em;
      text-align: right;
      word-wrap: break-word;
      word-break: break-word;
      &.label-required{
        &:before{
          content: '*';
          display: inline-block;
          margin-right: 4px;
          line-height: 1;
          font-family: SimSun;
          font-size: 14px;
          color: #ed4014;
        }
      }
    }
    .details-value {
      padding-left: 5px;
      flex: 100;
      line-height: 1.2em;
      text-align: left;
      word-wrap: break-word;
      word-break: break-word;
    }
    &:nth-of-type(2n-1) {
      padding-right: 10px;
    }
    &:nth-of-type(2n) {
      padding-left: 10px;
    }
    &.not-vertical-center{
      align-items: initial;
    }
  }
  .details-img-list{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    margin-top: 5px;
    img {
      // flex: 100;
      margin: 0px 10px 10px 0px;
      max-height: 74px;
      padding: 2px 5px;
      border: 1px solid #ccc;
      object-fit: contain;
    }
  }
  .container-full {
    width: 100%;
  }
  .container-half{
    width: 50%;
  }
  .content-inline{
    position: relative;
    display: inline-block;
  }
  .li-style-initial{
    margin-left: calc(1em + 1px);
    li {
      list-style: initial;
    }
  }
  .item-label-tip{
    position: absolute;
    bottom: 35px;
    left: 50px;
    display: flex;
    border: 4px solid #333;
    .label-tip-item{
      padding: 6px 10px;
      border-right: 4px solid #333;
      font-weight: bold;
      &:last-child{
        border-right: none;
      }
    }
  }
  .style-pre-wrap{
    white-space: pre-wrap;
  }
  .product-details {
    display: flex;
    .product-item{
      display: flex;
      margin-left: 60px;
      &:first-child{
        margin-left: 0;
      }
      .details-value{
        padding-left: 5px;
      }
    }
  }
}
</style>
